import {
	RECEIVE_VARIABLE_SERVER,
	UPDATE_ID_MENU_SELECTED,
	PRE_SET_SELECTED_DATE,
	UPDATE_VARIABLE_SERVER,
} from '../constants/variableServer';

const initialState = [];

const reducer = function variableServerReducer(state = initialState, action) {
	const newState = [...state];
	switch (action.type) {
		case RECEIVE_VARIABLE_SERVER:
			if (action.response.menuEmpty || action.response.result.length === 0) {
				return newState;
			}
			const variableServer = action.response.result;
			return variableServer;
		case UPDATE_ID_MENU_SELECTED:
			const variables = newState.map(object => {
				if (object.key_ === 'selected_menu') {
					object.value = action.response;
				}
				return object;
			});
			return variables;
		// La clé peut être absente du store : variable_server n'est pas
		// forcément peuplé pour toutes les clés, l'écriture fait un upsert.
		case UPDATE_VARIABLE_SERVER: {
			const exists = newState.some(v => v.key_ === action.key);
			return exists
				? newState.map(v =>
						v.key_ === action.key ? { ...v, value: action.value } : v
				  )
				: [...newState, { key_: action.key, value: action.value }];
		}
		default:
			return state;
	}
};

export default reducer;
